import { register } from "@rill/loader";
import {
  CONFIGS_BY_CLIENT_ID_CACHE_OPTS,
  SECTION_BLOCKS_CACHE_OPTS,
} from "../utils/configs-by-client-id-cache";

register(
  {
    name: "clientConfiguration",
    meta: [
      "no-bust",
      "client-configurations",
      "client-configuration-templates",
      // A client with no assigned doc and no coach default gets a config
      // synthesized from live data (see msb-api build-config-from-data.js) —
      // bust on writes to the collections that feeds, same set as
      // clientConfigSectionBlocks below.
      "exercise",
      "nutrition-plan",
      "meal-plan",
      "client-goals",
      "user",
    ],
    ttl: "2 hours",
  },
  async ({ api }, { proxyAthlete }) => {
    const res = await api(`client-configurations/${proxyAthlete}`);
    return res.json();
  }
);

register(
  {
    name: "clientConfigSectionBlocks",
    meta: [
      "no-bust",
      "exercise",
      "nutrition-plan",
      "meal-plan",
      "client-goals",
      "user",
    ],
    ttl: "2 hour",
  },
  async ({ api }, { proxyAthlete }) => {
    const res = await api(`client-configurations/section-turn-off-validator`, {
      query: { clientId: proxyAthlete },
    });
    const data = await res.json();
    return data.results ?? {};
  }
);

register(
  {
    name: "clientConfigWidgetAvailability",
    meta: ["no-bust", "widget"],
    ttl: "2 hours",
  },
  async ({ api }) => {
    const res = await api("client-configurations/widget-availability");
    const data = await res.json();
    return data;
  }
);

register(
  {
    name: "sectionBlocksByClientId",
    ...SECTION_BLOCKS_CACHE_OPTS,
  },
  async ({ api }, { clientIds } = {}) => {
    if (!clientIds) return {};
    const res = await api(
      `client-configurations/section-turn-off-validator/batch`,
      { query: { clientIds } }
    );
    const data = await res.json();
    return data.sectionBlocksByClientId ?? {};
  }
);

register(
  {
    name: "configsByClientId",
    // Same tags as the shared configs map the list accumulates (see
    // CONFIGS_CACHE_META for why each one is there).
    ...CONFIGS_BY_CLIENT_ID_CACHE_OPTS,
  },
  async ({ api }, { filterGroup, organizationCoach, clientIds } = {}) => {
    // With an explicit `clientIds` batch (one page of a paginated table), we
    // POST it alongside the filter/organizationCoach so the backend can
    // authorize it (intersect against the same scope it'd otherwise resolve
    // on its own) instead of trusting it outright. Otherwise we never ship
    // client ids at all — the backend resolves them itself from the coach's
    // own session ("organization" for every athlete across the coach's org,
    // a group name for athletes tagged with it in any coach's list,
    // `organizationCoach` for one specific other coach's athletes, or no
    // filter for the logged-in coach's own athletes). See
    // client-configurations/list in msb-api for the resolution logic.
    const res = clientIds
      ? await api(`client-configurations/list`, {
          method: "POST",
          body: { clientIds, filterGroup, organizationCoach },
        })
      : await api(`client-configurations/list`, {
          query:
            filterGroup || organizationCoach
              ? {
                  ...(filterGroup ? { filterGroup } : null),
                  ...(organizationCoach ? { organizationCoach } : null),
                }
              : undefined,
        });
    const data = await res.json();
    const { configsByClientId } = data;
    return configsByClientId;
  }
);
